import {getRequest, postRequest, formDataRequest} from "../libs/AxiosService.util";

export async function fetchWhatsappConversations(params= {}) {
    return await getRequest('whatsapp/conversations', params);
}

export async function fetchWhatsappMessages(conversationId, params = {}) {
    return await getRequest(`whatsapp/conversations/${conversationId}/messages`, params);
}

export async function serviceSendMessage(params) {
    return await postRequest('whatsapp/send/message', params);
}

/** Multipart: field `file` + `conversation_id`; `message` / `caption` optional (e.g. image caption). */
export async function serviceSendWhatsappWithMedia({ conversation_id, file, message = '', caption = '' }) {
    const formData = new FormData();
    formData.append('conversation_id', conversation_id);
    formData.append('file', file);
    if (message) {
        formData.append('message', message);
    }
    if (caption) {
        formData.append('caption', caption);
    }
    return formDataRequest('whatsapp/send/message', formData);
}
export async function serviceInitiateCoversation(params) {
    return await postRequest('whatsapp/initiate/conversation', params);
}
